
import { Mixins, Component, Prop, Ref } from "vue-property-decorator";
import { GSAP } from "_core";
import { onResize, onView } from "_mixins";
import { LinkLogic, SmartText, SmartSVG, SVGLibraryCustom } from "_components";
import { generateID } from "_utils";
import { EventTakeoverType } from "../../types";

@Component({
  name: "HomepageEventTakeoverMobButtons",
  components: { LinkLogic, SmartText, SmartSVG },
})
export default class HomepageEventTakeoverMobButtons extends Mixins(
  onResize,
  onView
) {
  @Prop() data: EventTakeoverType;
  @Ref() roller: Array<HTMLElement>;

  SVGLibraryCustom = SVGLibraryCustom;

  rootClass = "p-event-takeover-mob-buttons";
  rollerAnimation = [];
  rollAmount = 0;
  repeat: { id: string; amount: number; rollAmount: number }[] = [];

  playing = false;
  renderKey = 1;

  get ID() {
    return generateID();
  }

  get buttons() {
    return this.data && this.data.buttons;
  }

  onView(inView) {
    if (inView && !this.playing) this.createRoller();
    else if (!inView && this.playing) this.kill();
  }

  kill() {
    for (const animation of this.rollerAnimation) {
      animation.kill();
    }
  }

  createRepeatingWords() {
    return new Promise<void>((resolve, reject) => {
      this.repeat = this.roller.map(() => ({
        id: generateID(),
        amount: 1,
        rollAmount: 0,
      }));

      this.$nextTick(() => {
        try {
          this.roller.forEach((roller, index) => {
            const unitWidth = (roller.children[0] as HTMLElement)?.offsetWidth;
            if (!unitWidth) return;
            let targetScreens = 2;
            if (unitWidth * 2 > window.innerWidth) targetScreens = 3;
            let repeat = Math.floor(
              (window.innerWidth * targetScreens) / unitWidth
            );
            if (repeat % 2 !== 0) repeat++;
            this.repeat[index] = {
              id: `${generateID()}-${index}`,
              amount: repeat + 2,
              rollAmount: unitWidth + 32,
            };
          });
          this.renderKey++;
          this.$nextTick(() => {
            resolve(); // Resolve the promise when everything is done
          });
        } catch (error) {
          reject(error); // Reject the promise in case of any error
        }
      });
    });
  }

  createRoller() {
    this.createRepeatingWords().then(() => {
      this.roller.forEach((roller, index) => {
        this.setRollerAnimation(
          roller.children[0] as HTMLElement,
          index,
          this.repeat[index].rollAmount
        );
      });
    });
  }

  private setRollerAnimation(
    target: HTMLElement,
    index: number,
    offset: number
  ) {
    const forwards = index % 2 === 0;

    this.rollerAnimation[index] = GSAP.fromTo(
      target,
      { x: forwards ? 0 : offset * -2 },
      {
        x: forwards ? offset * -2 : 0,
        ease: "linear",
        repeat: -1,
        duration: 25,
      }
    );
  }

  onResize() {
    this.kill();
    if (this.isMob) {
      this.createRoller();
    }
  }
}
